import type CK from '~/types/contentking';

import useAffectedLinksFilter from '~/hooks/useAffectedLinksFilter';
import useCountPages from '~/hooks/useCountPages';

import {
	type IssueName,
} from '~/model/issuesNew';



function useCountAffectedLinks(
	issueName: IssueName,
	websiteId: CK.WebsiteId,
	applyExtraCriteria: boolean,
) {
	const filter = useAffectedLinksFilter(issueName, applyExtraCriteria);

	return useCountPages({
		filter: filter ?? {},
		pollIntervalInMilliseconds: 30000,
		skip: filter === null,
		websiteId,
	});
}



export default useCountAffectedLinks;
